import { render, staticRenderFns } from "./job-response-details.vue?vue&type=template&id=65d8bd3c&scoped=true&"
import script from "./job-response-details.vue?vue&type=script&lang=js&"
export * from "./job-response-details.vue?vue&type=script&lang=js&"
import style0 from "./job-response-details.vue?vue&type=style&index=0&id=65d8bd3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d8bd3c",
  null
  
)

export default component.exports